<template>
  <modalDialog class="modal--personalized" @close="close">
    <p class="" slot="header">
      {{
        expedition.consignmentType === "PICKUP"
          ? $t("xpo.pickupDetails")
          : $t("xpo.deliveryDetails")
      }}
    </p>
    <div slot="form" class="form">
      <section class="block-scroll">
        <!-- Information -->
        <div class="detail">
          <p class="detail__title detail__title--document">
            {{ $t("information") }}
          </p>
          <div class="detail__details">
            <div class="item">
              <span class="item__title">{{ $t("packages") }}:</span>
              <span class="item__value">
                {{ expedition.palletNumber }}
              </span>
            </div>
            <div class="item" v-if="expedition.weight != null">
              <span class="item__title">{{ $t("weight") }}:</span>
              <i18n-n
                tag="span"
                class="item__value"
                :value="expedition.weight"
              ></i18n-n>
            </div>
            <div class="item" v-if="expedition.volume != null">
              <span class="item__title">{{ $t("volume") }}:</span>
              <i18n-n
                tag="span"
                class="item__value"
                :value="expedition.volume"
              ></i18n-n>
            </div>
          </div>
        </div>

        <!-- Delivery details -->
        <div class="detail" v-if="expedition.observations1 != null">
          <p class="detail__title detail__title--document">
            {{
              expedition.consignmentType === "PICKUP"
                ? $t("xpo.pickupDetails")
                : $t("xpo.deliveryDetails")
            }}
          </p>
          <div class="detail__details">
            <div class="item">
              <span class="item__title">
                {{ expedition.observations1 }}
              </span>
            </div>
          </div>
        </div>
      </section>

      <!-- More details -->
      <section
        class="detail detail--services block-scroll"
        v-if="
          (actionsEnabled || additionalServicePurchased) &&
            this.expedition.additionalServices.length > 0 &&
            !this.loadingActionAssess &&
            this.expedition.consignmentType !== 'PICKUP'
        "
      >
        <p class="detail__title detail__title--services">
          {{ $t("xpo.moreServices") }}
        </p>
        <div
          v-for="service in expedition.additionalServices"
          :key="service.code"
        >
          <div
            class="service"
            :class="
              (service.selected ? 'service--selected' : '') +
                (service.purchased ? 'service--purchased' : '')
            "
          >
            <p class="service__name">
              {{ $t(service.text) }}
            </p>
            <div
              class="info-container"
              v-on:click="setToolTipHidden(service, !getToolTipHidden(service))"
            >
              <div class="info-icon">
                <font-awesome-icon class="service__info" icon="info-circle" />
              </div>
              <div class="info-content" v-if="!getToolTipHidden(service)">
                {{ $t(service.translatedDescription) }}
              </div>
            </div>
            <div class="service__price" v-if="!service.purchased">
              <i18n-n
                class="amount"
                tag="span"
                :value="service.price != undefined ? service.price : 0"
                format="currency"
              ></i18n-n>
              <span class="tax">{{ $t("xpo.moreServices.priceTax") }}</span>
            </div>
            <img
              alt=""
              class="service__action"
              src="./assets/plus.svg"
              v-on:click="setShowConfirmMessageDialog(true, service)"
              v-if="
                !service.purchased &&
                  !service.incompatible &&
                  !service.dependent &&
                  service.price != undefined &&
                  service.translatedMessage != undefined &&
                  !service.selected
              "
            />
            <img
              alt=""
              class="service__action"
              src="./assets/plus.svg"
              v-on:click="addAdditionalService(service)"
              v-if="
                !service.purchased &&
                  !service.incompatible &&
                  !service.dependent &&
                  service.price != undefined &&
                  (service.translatedMessage == undefined || service.selected)
              "
            />
            <img
              alt=""
              class="service__action--purchased"
              src="./assets/check.svg"
              v-else-if="service.purchased"
            />
            <confirmMessageDlg
              v-if="showConfirmMessageDialog"
              @cancel="cancelConfirmMessageDialog"
              @accept="acceptConfirmMessageDialog"
            >
              <p slot="header">{{ $t("global.alert") }}</p>
              <p slot="form" class="btn btn--white modal__btn">
                {{ selectedServiceForAlert.translatedMessage }}
              </p>
            </confirmMessageDlg>
          </div>
        </div>
      </section>
      <section>
        <confirmDlg
          v-if="showCustomErrorMessageDialog"
          @close="closeCustomErrorMessageDialog"
        >
          <p slot="header">{{ $t("global.error") }}</p>
          <p slot="form" class="btn btn--white modal__btn">
            {{ customErrorMessage }}
          </p>
        </confirmDlg>
      </section>
    </div>
    <div slot="footer">
      <button
        save
        class="btn btn--red modal__btn button-save"
        @click="save"
        :disabled="!additionalServiceIsSelected"
        v-if="actionsEnabled && this.expedition.additionalServices.length > 0"
      >
        {{ $t("global.button.save") }}
      </button>
      <button cancel class="btn btn--white modal__btn" @click="close">
        {{ $t("global.button.cancel") }}
      </button>
    </div>
  </modalDialog>
</template>

<script>
import modalDialog from "@/components/ModalDialogFrame.vue";
import confirmDlg from "@/components/MessageDialog.vue";
import confirmMessageDlg from "@/components/ConfirmMessageDialog.vue";
import http from "@/http-commons";

const CONTEXT = "/productsTypes";

export default {
  components: {
    modalDialog,
    confirmDlg,
    confirmMessageDlg
  },
  props: {
    expedition: {
      required: true
    },
    actionsEnabled: {
      type: Boolean,
      required: true
    }
  },
  name: "DialogDetails",
  data: () => ({
    loadingActionAssess: false,
    showRelatedErrorModal: false,
    errorMessage: null,
    additionalServicesSelected: null,
    additionalServiceIsSelected: false,
    additionalServicePurchased: false,
    additionalService: {
      translatedName: "",
      translatedDescription: "",
      price: null,
      realPrice: null,
      originalPrice: null,
      selected: false,
      purchased: false,
      incompatible: false,
      dependent: false,
      code: ""
    },
    showCustomErrorMessageDialog: false,
    customErrorMessage: null,
    showConfirmMessageDialog: false,
    selectedServiceForAlert: null,
    customAlertMessage: null
  }),
  methods: {
    setToolTipHidden(service, value) {
      service.toolTipHidden = value;
      this.$forceUpdate();
    },
    getToolTipHidden(service) {
      return service.toolTipHidden;
    },
    getAlertMessage(service) {
      return service.translatedMessage;
    },
    openCustomErrorMessageDialog() {
      this.showCustomErrorMessageDialog = true;
      this.$forceUpdate();
    },
    closeCustomErrorMessageDialog() {
      this.showCustomErrorMessageDialog = false;
      this.customErrorMessage = undefined;
    },
    cancelConfirmMessageDialog() {
      this.showConfirmMessageDialog = false;
      this.selectedServiceForAlert = undefined;
    },
    acceptConfirmMessageDialog() {
      this.showConfirmMessageDialog = false;
      this.addAdditionalService(this.selectedServiceForAlert);
      this.selectedServiceForAlert = undefined;
    },
    setShowConfirmMessageDialog(value, service) {
      this.showConfirmMessageDialog = value;
      this.selectedServiceForAlert = service;
    },
    formatData(additionalServices, serviceData) {
      let self = this;
      additionalServices.forEach(function(service) {
        (service.relations = []),
          (service.reverseRelations = []),
          (service.incompatibleProducts = []),
          (service.requiredProducts = []);
      });

      for (const service of serviceData) {
        let addService = additionalServices.find(
          x => x.productTypeCode == service.code
        );

        if (addService != undefined) {
          addService.text = service.translatedName;
          addService.incompatible = false;
          addService.dependent = false;
          addService.price = service.price;
          addService.realPrice = service.price;
          addService.originalPrice = service.price;
          addService.selected = false;
          addService.relations = service.relations;
          addService.reverseRelations = service.reverseRelations;
          addService.translatedName = service.translatedName;
          addService.translatedDescription = service.translatedDescription;
          addService.translatedMessage = service.translatedMessage;
          addService.description = service.description;
          addService.toolTipHidden = true;
          if (addService.purchased) {
            self.additionalServicePurchased = true;
          }
        }
      }
    },
    checkRelations(service) {
      let self = this;
      let incompatibleProduct;
      self
        .getIncompatibleProducts(service)
        .forEach(function(incompatibleService) {
          if (
            self.expedition.additionalServices.find(
              x => x.productTypeCode == incompatibleService.productTypeCode
            ).dependent
          ) {
            incompatibleProduct = self.$t(
              "dialogDetails.errorMessage.dependent",
              {
                product: incompatibleService.productTypeCode
              }
            );
          }
        });
      self.getDependentProducts(service).forEach(function(dependentProduct) {
        if (
          self.expedition.additionalServices.find(
            x => x.productTypeCode == dependentProduct.productTypeCode
          ).incompatible
        ) {
          incompatibleProduct = self.$t(
            "dialogDetails.errorMessage.incompatible",
            {
              product: dependentProduct.productTypeCode
            }
          );
        }
      });

      return incompatibleProduct;
    },
    async fillAdditionalServices() {
      this.loadingActionAssess = true;
      return http
        .post(CONTEXT + "/assess", {
          language: this.$i18n.locale,
          volume: this.expedition.volume,
          weight: this.expedition.weight,
          client: this.expedition.senderCode
        })
        .then(response => {
          this.formatData(this.expedition.additionalServices, response.data);
          this.loadingActionAssess = false;
        })
        .catch(e => {
          console.log("Error: ", e);
          this.loadingActionAssess = false;
        });
    },
    addAdditionalService(service) {
      if (!service.selected) {
        this.errorMessage = this.checkRelations(service);
      }

      if (this.errorMessage == undefined) {
        if (service.selected) {
          this.unsetSelectedToRelatedServices(service);
        } else {
          this.setSelectedToRelatedServices(service);
        }

        this.recalculateIncompatibilites();
        this.resetPrices();
        this.setPrices();
        this.additionalServiceIsSelected =
          this.expedition.additionalServices.filter(x => x.selected).length > 0;
        this.$forceUpdate();
      } else {
        this.customErrorMessage = this.errorMessage;
        this.openCustomErrorMessageDialog();
      }
    },
    resetPrices() {
      this.expedition.additionalServices.forEach(function(service) {
        service.price = service.realPrice;
      });
    },
    setPrices() {
      this.expedition.additionalServices.forEach(function(service) {
        service.reverseDependentProducts.forEach(function(
          reverseRelatedProduct
        ) {
          if (service.selected) {
            reverseRelatedProduct.price -= service.realPrice;
            if (reverseRelatedProduct.price < 0) {
              reverseRelatedProduct.price = 0;
            }
          }
        });
      });
    },
    recalculateIncompatibilites() {
      let additionalServices = this.$parent.expedition.additionalServices;
      additionalServices.forEach(function(service) {
        service.incompatible =
          (service.requiredProducts.find(x => x.selected || x.purchased) ==
            undefined &&
            service.requiredProducts.length > 0) ||
          (service.incompatibleProducts.find(x => x.selected || x.purchased) !=
            undefined &&
            service.incompatibleProducts.length > 0);

        if (service.incompatible) {
          service.selected = false;
        }
      });
    },
    setSelected(service, value) {
      let self = this;
      if (!service.purchased) {
        service.selected = value;
      }
      service.dependentProducts.forEach(function(dependentService) {
        if (!dependentService.purchased) {
          self.setSelected(dependentService, value);
        }
      });
    },
    setSelectedToRelatedServices(service) {
      let self = this;
      self.setSelected(service, true);
    },
    unsetSelectedToRelatedServices(service) {
      let self = this;
      service.selected = false;
      service.reverseDependentProducts.forEach(function(reverseProduct) {
        self.unsetSelectedToRelatedServices(reverseProduct);
      });
    },
    setInitialDependencies() {
      let self = this;
      let allProductsTypes = this.expedition.additionalServices;
      if (allProductsTypes != undefined) {
        allProductsTypes.forEach(function(service) {
          self.setIncompatibleProducts(service);
          self.setDependentProducts(service);
          self.setReverseDependentProducts(service);
          self.setRequiredProducts(service);
        });
      }
    },
    setInitialIncompatibleProducts() {
      let self = this;
      let allProductsTypes = this.expedition.additionalServices;
      if (allProductsTypes != undefined) {
        allProductsTypes.forEach(function(service) {
          service.incompatible =
            self.checkIfIncompatibleProductIsSelectedOrPurchased(service) ||
            !self.checkIfRequiredProductIsSelectedOrPurchased(service);
        });
      }
    },
    checkIfIncompatibleProductIsSelectedOrPurchased(service) {
      let incompatible = false;
      service.incompatibleProducts.forEach(function(incompatibleProduct) {
        if (incompatibleProduct.selected || incompatibleProduct.purchased) {
          incompatible = true;
        }
      });
      return incompatible;
    },
    checkIfRequiredProductIsSelectedOrPurchased(service) {
      let required = false;
      if (service.requiredProducts.length == 0) {
        required = true;
      }
      service.requiredProducts.forEach(function(requiredProduct) {
        if (requiredProduct.selected || requiredProduct.purchased) {
          required = true;
        }
      });
      return required;
    },
    setIncompatibleProducts(service) {
      service.incompatibleProducts = this.getIncompatibleProducts(service);
    },
    setDependentProducts(service) {
      service.dependentProducts = this.getDependentProducts(service);
    },
    setReverseDependentProducts(service) {
      service.reverseDependentProducts = this.getReverseDependentProducts(
        service
      );
    },
    setRequiredProducts(service) {
      service.requiredProducts = this.getRequiredProducts(service);
    },
    setInitialPrices() {
      let self = this;
      let purchasedProductList = this.expedition.additionalServices.filter(
        x => x.purchased
      );
      if (purchasedProductList == undefined) {
        purchasedProductList = [];
      }
      purchasedProductList.forEach(function(purchasedService) {
        purchasedService.price = purchasedService.purchasedPrice;
        self.discountPurchasedPrice(purchasedService);
      });
    },
    discountPurchasedPrice(purchasedService) {
      let dependentPurchasedList = this.getReverseDependentProducts(
        purchasedService
      );
      dependentPurchasedList.forEach(function(service) {
        service.price -= purchasedService.originalPrice;
        service.realPrice = service.price;
        service.discountedPrice = true;
      });
    },
    getReverseDependentProducts(service) {
      let self = this;
      let relatedList = [];
      service.reverseRelations.forEach(function(relatedElement) {
        let relatedService = self.expedition.additionalServices.find(
          x =>
            x.productTypeCode == relatedElement.code &&
            relatedElement.relation == "D"
        );
        if (relatedService != undefined) {
          relatedList.push(relatedService);
        }
      });
      return relatedList;
    },
    getDependentProducts(service) {
      let self = this;
      let relatedList = [];
      if (service.relations != undefined) {
        service.relations.forEach(function(relatedElement) {
          let relatedService = self.expedition.additionalServices.find(
            x =>
              x.productTypeCode == relatedElement.code &&
              relatedElement.relation == "D"
          );
          if (relatedService != undefined) {
            relatedList.push(relatedService);
          }
        });
      }
      return relatedList;
    },
    getRequiredProducts(service) {
      let self = this;
      let relatedList = [];
      if (service.relations != undefined) {
        service.relations.forEach(function(relatedElement) {
          let relatedService = self.expedition.additionalServices.find(
            x =>
              x.productTypeCode == relatedElement.code &&
              relatedElement.relation == "C"
          );
          if (relatedService != undefined) {
            relatedList.push(relatedService);
          }
        });
      }
      return relatedList;
    },
    getIncompatibleProducts(service) {
      let self = this;
      let relatedList = [];

      service.reverseRelations.forEach(function(relatedElement) {
        let relatedService = self.expedition.additionalServices.find(
          x =>
            x.productTypeCode == relatedElement.code &&
            relatedElement.relation == "I"
        );
        if (relatedService != undefined) {
          relatedList.push(relatedService);
        }
      });

      service.relations.forEach(function(relatedElement) {
        let relatedService = self.expedition.additionalServices.find(
          x =>
            x.productTypeCode == relatedElement.code &&
            relatedElement.relation == "I"
        );
        if (relatedService != undefined) {
          relatedList.push(relatedService);
        }
      });

      return relatedList;
    },
    save() {
      this.additionalServicesSelected = this.expedition.additionalServices.filter(
        x => x.selected
      );
      this.$emit("save", this.additionalServicesSelected);
    },
    close() {
      this.$emit("close");
    }
  },
  async beforeMount() {
    await this.fillAdditionalServices();
    this.expedition.additionalServices.sort(function(a, b) {
      return a.price - b.price;
    });
    this.setInitialPrices();
    this.setInitialDependencies();
    this.setInitialIncompatibleProducts();
  },
  mounted() {
    this.$plausible.trackEvent("showDetails");
  }
};
</script>

<style src="./css/common.css"></style>

<style scoped>
.detail {
  border-bottom: 0px;
}

.detail--services {
  margin-top: 10px;
}

.detail__title--document {
  background: url("./assets/document.svg") no-repeat;
}

.detail__title--services {
  background: url("./assets/services.svg") no-repeat;
}

.service {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  padding: 7px 0 7px 0;
  font-family: Roboto;
}
.service:hover {
  background-color: #f2f2f2;
  box-shadow: -15px 0px 0px 0px #f2f2f2, 15px 0px 0px 0px #f2f2f2;
}

.service--selected .service__name,
.service--purchased .service__name {
  font-weight: bold;
}
.service--selected .service__price > .amount,
.service--purchased .service__price > .amount {
  color: #cc0000;
  font-weight: bold;
}

.service__name {
  grid-column: 1;
  font-size: 13px;
  font-weight: 300;
  letter-spacing: 0;
  line-height: 15px;
  margin: 0;
  color: #43494d;
  align-self: center;
  word-wrap: break-word;
  min-width: 100px;
}

.service__price {
  grid-column: 3;
  justify-self: end;
  align-self: center;
  display: flex;
  flex-direction: column;
  text-align: center;
  color: #858585;
  font-weight: 300;
  letter-spacing: 0;
}
.service__price > .amount {
  font-size: 15px;
  line-height: 20px;
}
.service__price > .tax {
  font-size: 11.5px;
  line-height: 15px;
}

.service__action,
.service__action--purchased {
  grid-column: 4;
  justify-self: right;
  align-self: center;
  cursor: pointer;
}
.service__info {
  grid-column: 2;
  justify-self: right;
  align-self: center;
  cursor: pointer;
}

.service__action--purchased {
  width: 1.5rem;
  cursor: auto;
}

.block-scroll {
  overflow-y: auto;
  max-height: 25vh;
}

.form {
  max-height: 50vh;
  overflow-y: auto;
}

.info-container {
  display: flex;
  align-items: center;
  flex-flow: column-reverse;
}
.info-content {
  position: fixed;
  transform: translateY(-35px) translateX(5px);
  color: #ffffff;
  font-family: Roboto;
  font-size: 11.5px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 14.4px;
  background-color: #43494d;
  box-shadow: 0 2px 2px 0 rgba(71, 70, 71, 0.26);
  padding: 10px;
  border-radius: 5px;
  width: 200px;
}
.info-content:before {
  content: "";
  border-left-color: transparent;
  border-bottom-color: transparent;
  border-right-color: transparent;
  position: absolute;
  bottom: -18px;
  right: 105px;
}
.info-content > span {
  display: block;
}
.info-icon > svg {
  position: relative;
  vertical-align: 50%;
}
</style>
